import React from 'react';
import { PapiStudioOrdersInit } from '@wix/da-papi-types';
import { useStream } from '@wix/da-shared-react/pkg/utils/hooks/useStream';
import { STUDIO_ORDERS_BY_DEVIATION_STREAM } from '../../../../constants';
import OriginalOrdersCard from '../OriginalOrdersCard/OriginalOrdersCard';

import s from './OrdersByOriginalPageContent.scss';

const OrdersByOriginalPageContent: React.FC = () => {
  const { items: orders } = useStream<PapiStudioOrdersInit['orders'][number]>(
    STUDIO_ORDERS_BY_DEVIATION_STREAM.streamId,
    STUDIO_ORDERS_BY_DEVIATION_STREAM.streamThrottle,
    STUDIO_ORDERS_BY_DEVIATION_STREAM.streamConfig
  );

  return (
    <div className={s['root']}>
      {orders.map((order, idx) => (
        <OriginalOrdersCard key={idx} order={order} />
      ))}
    </div>
  );
};
OrdersByOriginalPageContent.displayName = 'OrdersByOriginalPageContent';

export default OrdersByOriginalPageContent;
